import FetchApi from "../util/fetchApi";
const fetchApi = new FetchApi();

export default class SharePointService {
  async getData(data) {
    return (await fetchApi.post(`/sharepoint`, data)).data;
  }

  async delete(data) {
    return (await fetchApi.post(`/sharepoint/delete`, data)).data;
  }

  async download(Workspace_id, data) {
    const apiURL = (process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "") + "/api/v1";
    window.location.href = apiURL + `/sharepoint/${Workspace_id}/download?` + new URLSearchParams(data).toString();
  }

  async upload(formData, ProcessQueue_id, customHeaders) {
    return (
      await fetchApi.postFormData(`/sharepoint/upload?ProcessQueue_id=${ProcessQueue_id}`, formData, customHeaders)
    ).data;
  }

  async manageObject(data) {
    return (await fetchApi.post(`/sharepoint/manage-object`, data)).data;
  }
}
